import React, { useEffect, useState } from 'react';
import './header.css';
import Sicons from './Icon';
import 'bootstrap/dist/css/bootstrap.min.css';
import Carousel from 'react-bootstrap/Carousel';
import logo from '../../assets/nav-logo.webp';
import slider1 from '../../assets/showcase-1.webp';
import slider2 from '../../assets/showcase-2.webp';
import { FaWhatsapp } from "react-icons/fa6";
import { MdLocalPhone } from "react-icons/md";

export default function Header() {
    const [addBlur, setAddBlur] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setAddBlur(window.innerWidth <= 768);
        };

        // Initial check on mount
        handleResize();

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Cleanup the event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div>
            <section id='showcase'>
                <div data-aos="fade-down"
                    data-aos-easing="linear"
                    data-aos-duration="600"
                    data-aos-offset="0">
                    <Carousel slide interval={4500} className="showcase-carousel">
                        <Carousel.Item>
                            <div className={addBlur ? 'blur Cbg' : 'Cbg'}>
                                <img
                                    className="d-block w-100"
                                    src={slider1}
                                    alt="First slide"
                                />
                                <div className="slide-overlay"></div>
                            </div>
                            <Carousel.Caption className='slider-content'>
                                <img src={logo} alt="logo" className="slider-logo" />
                                <h5>
                                    <strong className="slider-main-title">مرحبا بكم بشركة إبراهيم الزهراني وأحمد المالكي</strong>
                                    <span className="slider-subtitle">محامون | مستشارون | محكمون</span>
                                    <span className="slider-desc">نحمي الحقوق والمصالح بالمعايير المهنية بكل&nbsp;إحترافية&nbsp;وأمانة</span>
                                </h5>
                                <div className="slider-cta-wrap">
                                    <a
                                        href="https://api.whatsapp.com/send?phone=966551155707"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="slider-cta-btn cta-whatsapp"
                                    >
                                        <FaWhatsapp className="cta-icon" />
                                        <span>إستشارة فورية</span>
                                    </a>
                                </div>
                            </Carousel.Caption>
                        </Carousel.Item>

                        <Carousel.Item>
                            <div className={addBlur ? 'blur Cbg' : 'Cbg'}>
                                <img
                                    className="d-block w-100"
                                    src={slider2}
                                    alt="Second slide"
                                />
                                <div className="slide-overlay"></div>
                            </div>
                            <Carousel.Caption className='slider-content'>
                                <img src={logo} alt="logo" className="slider-logo" />
                                <h5>
                                    <strong className="slider-main-title">مرحبا بكم بشركة إبراهيم الزهراني وأحمد المالكي</strong>
                                    <span className="slider-subtitle">محامون | مستشارون | محكمون</span>
                                    <span className="slider-desc">الوجهة الموثوقة لخدمات قانونية&nbsp;ذات&nbsp;جودة&nbsp;عالية</span>
                                </h5>
                                <div className="slider-cta-wrap">
                                    <a
                                        href="tel:+966551155707"
                                        className="slider-cta-btn cta-call"
                                    >
                                        <MdLocalPhone className="cta-icon" />
                                        <span>تواصل الآن</span>
                                    </a>
                                </div>
                            </Carousel.Caption>
                        </Carousel.Item>
                    </Carousel>
                </div>

                <Sicons />
            </section>
        </div>
    );
};
